import { DiscoveryApi, FetchApi } from '@mainstage/core-plugin-api';
import { handleFailedResponse } from '@agilelab/plugin-wb-platform-common';
import {
  KnowledgeGraphManagerApi,
  NodesChildrenRequest,
  NodesResolveRequest,
  NodesResponse,
  NodesSearchRequest,
  NodesSearchResponse,
} from '@agilelab/plugin-wb-marketplace-common';

/**
 * Client implementation for Knowledge Graph Manager API
 * @public
 */
export class KnowledgeGraphManagerClient implements KnowledgeGraphManagerApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor(options: { discoveryApi: DiscoveryApi; fetchApi: FetchApi }) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
  }

  private async getBaseUrl(): Promise<string> {
    return this.discoveryApi.getBaseUrl('marketplace');
  }

  async resolveNodes(request: NodesResolveRequest): Promise<NodesResponse> {
    const baseUrl = await this.getBaseUrl();
    const url = `${baseUrl}/knowledge-graph/v1/nodes/resolve`;

    const response = await this.fetchApi.fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(request),
    });

    await handleFailedResponse(response);
    return response.json();
  }

  async getChildren(request: NodesChildrenRequest): Promise<NodesResponse> {
    const baseUrl = await this.getBaseUrl();
    const url = `${baseUrl}/knowledge-graph/v1/nodes/children`;

    const response = await this.fetchApi.fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(request),
    });

    await handleFailedResponse(response);
    return response.json();
  }

  async searchNodes(request: NodesSearchRequest): Promise<NodesSearchResponse> {
    const baseUrl = await this.getBaseUrl();
    const url = `${baseUrl}/knowledge-graph/v1/nodes/search`;

    const response = await this.fetchApi.fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(request),
    });

    await handleFailedResponse(response);
    return response.json();
  }
}
